export enum UserRole {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  USER = 'USER',
}

export const userRoleNameMap: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Yönetici',
  [UserRole.EDITOR]: 'Editör',
  [UserRole.USER]: 'Kullanıcı',
};
